import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
    selector: 'tran-tertiary-button',
    imports: [TranslatePipe],
    templateUrl: './tertiary-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TertiaryButtonComponent extends BaseButtonComponent {}
